import { useFormikContext } from "formik";
import { useEffect } from "react";

const ClearOppositeField: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    if (values.regarding === "Customer") {
      setFieldValue("leadId", "");
    } else {
      setFieldValue("customerId", "");
    }
  }, [values.regarding, setFieldValue]);

  return null;
};

export default ClearOppositeField;